import React, { forwardRef, useState, useEffect, useRef } from "react";
// import "../../components/CommonStyle.css";
// import "./FindMember.css";
import CalendarImg from "../../Images/calendar.png";
// import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { screenConfig } from "../../config/screenConfig";
import { changeCreateMemberSection } from "../../store/screenSlice";
import InputFieldSmallDisabled from "../StyledComp/InputFieldSmallDisabled";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import "../../Styles/memberModal.css";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import IMember from "../../store/memberInterfaceStruct";
import ReactModal from "react-modal";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import MemberServices from "../../services/MemberServices";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import IOtherStateBar from "../../store/memberInterfaceStruct";
import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
import { collapseTextChangeRangesAcrossMultipleVersions } from "typescript";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface IConfiguration {
  [key: string]: any;
}

interface state {
  [key: string]: any;
}

interface Iarr {
  Id: number;
  MemberId: string;
}

const MDOtherStateBar: React.FC = () => {
  const currentMember = useAppSelector((state) => state.currentMember);
  console.log("PersonalInfo:", currentMember);
  // let otherStateData = currentMember.OtherStateBar;

  // let otherStateData: IOtherStateBar[]
  let [otherStateData, setotherStateData] = useState(
    currentMember.OtherStateBar
  );

  console.log("date1:", currentMember?.AdmitDate);
  console.log("date2:", dayjs(currentMember?.AdmitDate));
  //forced refresh
  const [key, setKey] = useState(0);

  const dispatch = useDispatch();
  // const [adminDate, setAdminDate] = useState(new Date());
  const [admitDate, setAdmitDate] = React.useState<Dayjs | null>(
    dayjs(currentMember?.AdmitDate)
  );

  const [selectedStates, setSelectedStates] = useState<state>({
    barId1: 0,
    barId2: 0,
    barId3: 0,
    barId4: 0,
  });

  const [admitDate1, setAdmitDate1] = useState<Dayjs | null>(null);
  const [admitDate2, setAdmitDate2] = useState<Dayjs | null>(null);
  const [admitDate3, setAdmitDate3] = useState<Dayjs | null>(null);
  const [admitDate4, setAdmitDate4] = useState<Dayjs | null>(null);
  const [barId1, setBarId1] = useState("");
  const [barId2, setBarId2] = useState("");
  const [barId3, setBarId3] = useState("");
  const [barId4, setBarId4] = useState("");

  const [state1, setState1] = useState("");
  const [state2, setState2] = useState("");
  const [state3, setState3] = useState("");
  const [state4, setState4] = useState("");

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  // const inputRefBarId1 = useRef(null);

  // const [textarea, setTextarea] = useState("Comments...");

  const [modalOpen, setModalOpen] = useState(false);

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  // if(otherStateData.length>0){
  // setAdmitDate4(otherStateData[3]?.AdmitDate,)
  // setAdmitDate4((otherStateData[3]?.AdmitDate!).toISOString().split("T")[0])
  // setAdmitDate1( dayjs(otherStateData[0].AdmitDate, "YYYY-MM-DD"))
  // dayjs(dateOfBirth, "YYYY-MM-DD").toDate().toISOString().split("T")[0]
  // }
  // if(otherStateData.length>1){
  //   setAdmitDate2( dayjs(otherStateData[1].AdmitDate, "YYYY-MM-DD"))
  // }
  // if(otherStateData.length>2){
  //   setAdmitDate3( dayjs(otherStateData[2].AdmitDate, "YYYY-MM-DD"))
  // }
  // if(otherStateData.length>3){
  //   setAdmitDate4( dayjs(otherStateData[3].AdmitDate, "YYYY-MM-DD"))
  // }

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getAdminList called");
      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    getConfigurationLists();
  }, []);

  useEffect(() => {
    console.log("use effect in model", otherStateData);
    setAdmitDate1(null);
    setAdmitDate2(null);
    setAdmitDate3(null);
    setAdmitDate4(null);
    setBarId1("");
    setBarId2("");
    setBarId3("");
    setBarId4("");
    setState1("");
    setState2("");
    setState3("");
    setState4("");
    if (otherStateData.length > 0) {
      setAdmitDate1(dayjs(dayjs(otherStateData[0].AdmitDate).format("MM-DD-YYYY"), "MM-DD-YYYY"));
      setBarId1(otherStateData[0]?.BarId!);
      setState1(otherStateData[0]?.OtherStateBarName!);
    }
    if (otherStateData.length > 1) {
      setAdmitDate2(
        otherStateData[1].AdmitDate != null
          ? dayjs(dayjs(otherStateData[1].AdmitDate).format("MM-DD-YYYY"), "MM-DD-YYYY")
          : null
      );
      setBarId2(otherStateData[1]?.BarId!);
      setState2(otherStateData[1]?.OtherStateBarName!);
    }
    if (otherStateData.length > 2) {
      setAdmitDate3(
        otherStateData[2].AdmitDate != null
          ? dayjs(dayjs(otherStateData[2].AdmitDate).format("MM-DD-YYYY"), "MM-DD-YYYY")
          : null
      );
      setBarId3(otherStateData[2]?.BarId!);
      setState3(otherStateData[2]?.OtherStateBarName!);
    }
    if (otherStateData.length > 3) {
      setAdmitDate4(
        otherStateData[3].AdmitDate != null
          ? dayjs(dayjs(otherStateData[3].AdmitDate).format("MM-DD-YYYY"), "MM-DD-YYYY")
          : null
      );
      setBarId4(otherStateData[3]?.BarId!);
      setState4(otherStateData[3]?.OtherStateBarName!);
    }
  }, [modalOpen]);
  const States = configurationList.StateList;
  /*
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    // setTextarea(event.target.value);
  };

  const handleSelect = (
    event: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    console.log("handleSelect ", event.target.name, event.target.value);

    console.log("index:", index, "/arraysize", otherStateData.length);

    const otherStateBarLocal = otherStateData.map((otherStateData, i) => {
      if (i == index) {
        return {
          ...otherStateData,
          OtherStateBarName: event.target.value,
        };
      } else return otherStateData;
    });

    console.log("changes other state:", otherStateBarLocal);

    setotherStateData(otherStateBarLocal);

    console.log("otherStateData AfterChange", otherStateData);
  };
*/
  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    console.log("updateSelectBox");
    console.log("name", event.target.name);
    console.log("selectedIndex", event.target.selectedIndex);
    console.log("value", event.target.value);
    switch (event.target.name) {
      case "State1":
        setState1(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId1: event.target.value,
        }));
        break;
      case "State2":
        setState2(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId2: event.target.value,
        }));
        break;
      case "State3":
        setState3(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId3: event.target.value,
        }));
        break;
      case "State4":
        setState4(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId4: event.target.value,
        }));
        break;
      default:
        break;
    }
  };
  const setBarId = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("barId event:", event.target.id, ":", event.target.value);
    switch (event.target.id) {
      case "OtherStatebarId1":
        setBarId1(event.target.value);
        break;
      case "OtherStatebarId2":
        setBarId2(event.target.value);
        break;
      case "OtherStatebarId3":
        setBarId3(event.target.value);
        break;
      case "OtherStatebarId4":
        setBarId4(event.target.value);
        break;
    }
    console.log("barId1:", barId1);
  };

  /*
  const handleDateChange = (date: string | null, index: number) => {
    console.log("date3: ", date);

    const otherStateBarLocal = otherStateData.map((otherStateData, i) => {
      if (i == index) {
        return {
          ...otherStateData,
          AdmitDate: date,
        };
      } 
      // else return otherStateData
      else return   {
        ...otherStateData,
        // AdmitDate: otherStateData.AdmitDate.toDate().toISOString().split("T")[0],
        AdmitDate : new Date(otherStateData.AdmitDate as string).toISOString().split("T")[0]
      }
    });

    console.log("changes other state:", otherStateBarLocal);
    setotherStateData(otherStateBarLocal);

    console.log("otherStateData AfterChange", otherStateData);
  };

  const onSubmit = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    dispatch(changeCreateMemberSection(screenConfig.otherStateBar));
  };
*/
  /*
  const openMemberEditOtherStateScreen = () => {
    dispatch(
      changeCurrentMemberMenu(screenConfig.memberEditOtherStateBarScreen)
    );
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // console.log("updateInput");
    console.log("updateInput1:", event.target.name);
    console.log(event.target.value);
    // dispatch(
    //   editMemberPersonal({
    //     key: event.target.name,
    //     value: event.target.value,
    //   })
    // );
  };

  const setConsolidatedDate = (passedDate: Dayjs, type: string) => {
    console.log("setConsolidatedDate", passedDate, type);
    // dispatch(
    //   editMemberPersonal({
    //     key: type,
    //     value: passedDate.toISOString().split("T")[0],
    //   })
    // );
  };

  const emptyFunction = (event: React.ChangeEvent<HTMLInputElement>): void => {
    //empty function
  };

  const handleChangeBarId = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    console.log("handleChangeBarId ", event.target.name, event.target.value);

    const otherStateBarLocal = otherStateData.map((otherStateData, i) => {
      if (i == index) {
        return {
          ...otherStateData,
          BarId: event.target.value,
        };
      } else return otherStateData;
    });

    console.log("changes other state:", otherStateBarLocal);
    // otherStateData2 =
    // otherStateData[index].OtherStateBarName = [...otherStateData, event.target.value];

    setotherStateData(otherStateBarLocal);

    console.log("otherStateData AfterChange", otherStateData);
  };

  */
  const onSubmitOtherStateBar = async (
    event: React.MouseEvent<HTMLElement>
  ) => {
    event.preventDefault();
    console.log("otherStateData before DB update:", otherStateData);
    console.log(state1, barId1, admitDate1);
    console.log(state2, barId2, admitDate2);
    // console.log(state2, barId2, dayjs(admitDate2, "YYYY-MM-DD").toDate().toISOString().split("T")[0])
    // console.log(state3, barId3, dayjs(admitDate3, "YYYY-MM-DD").toDate().toISOString().split("T")[0])
    // console.log(state4, barId4, dayjs(admitDate4, "YYYY-MM-DD").toDate().toISOString().split("T")[0])
    let otherStateBar = [];
    if (state1 !== "") {
      console.log("state1  is not empty");
      // if (admitDate1 == null) {
      //   alert("Enter Valid AdmitDate");
      //   return;
      // }
      otherStateBar.push({
        OtherStateBarName: state1,
        AdmitDate:
          admitDate1 != null
            ? dayjs(admitDate1, "YYYY-MM-DD").format("YYYY-MM-DD")
            : "--",
        BarId: barId1,
      });
    }
    if (state2 !== "") {
      console.log("state2  is not empty");
      // if (admitDate2 == null) {
      //   alert("Enter Valid AdmitDate");
      //   return;
      // }
      otherStateBar.push({
        OtherStateBarName: state2,
        AdmitDate:
          admitDate2 != null
            ? dayjs(admitDate2, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId2,
      });
    }
    if (state3 !== "") {
      console.log("state3  is not empty");
      // if (admitDate3 == null) {
      //   alert("Enter Valid AdmitDate");
      //   return;
      // }
      otherStateBar.push({
        OtherStateBarName: state3,
        AdmitDate:
          admitDate3 != null
            ? dayjs(admitDate3, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId3,
      });
    }
    if (state4 !== "") {
      console.log("state4  is not empty");
      // if (admitDate4 == null) {
      //   alert("Enter Valid AdmitDate");
      //   return;
      // }
      otherStateBar.push({
        OtherStateBarName: state4,
        AdmitDate:
          admitDate4 != null
            ? dayjs(admitDate4, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId4,
      });
    }
    console.log("otherStateBar joy", otherStateBar);

    const response = await MemberServices.editMemberOtherStateBar({
      MemberId: currentMember?.Id,
      OtherStateBars: otherStateBar,
    });
    console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("State Bars updated  successfully");
      setotherStateData(response.data.data[0].OtherStateBar);
      // dispatch(assignCurrentMember(response.data.data[0]));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
    } else {
      console.log("error");
    }

    setModalOpen(false);
  };

  const color1 = "#2d6289";
  const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  return (
    <div className="section-box">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Other State Bar</h1>
        <PageLink onClick={() => setModalOpen(true)}>Edit</PageLink>
      </div>
      <div>
        <div className="form-wrapper">
          {typeof otherStateData != "undefined" ? (
            otherStateData?.map((otherStateDataItem: any) => (
              <div className="form-wrapper" style={{ width: "100%" }}>
                <InputFieldSmallDisabled
                  id="State"
                  label="State"
                  value={otherStateDataItem?.OtherStateBarName}
                  isDisabled={true}
                />
                <InputFieldSmallDisabled
                  id="Admitdate"
                  label="Admit Date"
                  value={
                    (otherStateDataItem?.AdmitDate != null
                      ? dayjs(
                          otherStateDataItem?.AdmitDate,
                          "YYYY-MM-DD"
                        ).format("MM-DD-YYYY")
                      : null) as string
                  }
                  isDisabled={true}
                />
                {/* <div className="input-field-div-small"> */}
                <InputFieldSmallDisabled
                  id="OtherStatebarId"
                  label="Other State BarID"
                  value={
                    typeof otherStateData != "undefined"
                      ? otherStateDataItem?.BarId!
                      : ""
                  }
                  isDisabled={false}
                />
                {/* </div> */}
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Edit Other State Information</h1>
          <PageLink onClick={() => setModalOpen(false)}>Cancel</PageLink>
        </div>
        <div className="form-wrapper">
          <div className="input-field-div-wrapper">
            <div className="selectfield-label">State</div>
            <select
              className="dropdown-control-large-insidetextfield"
              name="State1"
              onChange={updateSelectBox}
            >
              <option value="">{state1}</option>
              {States?.map((State: any) => {
                const foundEntry1 = Object.entries(selectedStates).find(
                  ([key, value]) => value === State.StateName
                );
                let [foundKey, foundValue] = ["", ""];
                if (foundEntry1) {
                  [foundKey, foundValue] = foundEntry1;
                }
                console.log("foundEntry1:", foundKey, ":", foundValue);
                return foundKey === "barId2" ||
                  foundKey === "barId3" ||
                  foundKey === "barId4" ? (
                  <></>
                ) : (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="mt-1" style={{ width: "28%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="AdmitDate"
                  value={admitDate1}
                  onChange={(date) => date && setAdmitDate1(date)}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="OtherStatebarId1"
              name="OtherStatebarId1"
              placeholder=""
              autoComplete="off"
              value={barId1}
              onChange={setBarId}
            />
            <Label
              style={{ zIndex: "1" }}
              className="form-label"
              htmlFor="OtherStatebarId1"
            >
              Other State Bar ID
            </Label>
          </div>
          <PageLink
            onClick={() => {
              // otherStateData.splice(0, 1);
              // console.log("otherStateData:", otherStateData);
              // setKey((Key) => Key + 1);
              console.log("clearing");
              setBarId1("");
              setAdmitDate1(null);
              setState1("");
            }}
          >
            Clear
          </PageLink>
        </div>
        <div className="form-wrapper">
          <div className="input-field-div-wrapper">
            <div className="selectfield-label">State</div>
            <select
              className="dropdown-control-large-insidetextfield"
              name="State2"
              onChange={updateSelectBox}
            >
              <option value="">{state2}</option>
              {States?.map((State: any) => {
                const foundEntry1 = Object.entries(selectedStates).find(
                  ([key, value]) => value === State.StateName
                );
                let [foundKey, foundValue] = ["", ""];
                if (foundEntry1) {
                  [foundKey, foundValue] = foundEntry1;
                }
                console.log("foundEntry1:", foundKey, ":", foundValue);
                return foundKey === "barId1" ||
                  foundKey === "barId3" ||
                  foundKey === "barId4" ? (
                  <></>
                ) : (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="mt-1" style={{ width: "28%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="AdmitDate"
                  value={admitDate2}
                  onChange={(date) => date && setAdmitDate2(date)}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="OtherStatebarId2"
              name="OtherStatebarId2"
              placeholder=""
              autoComplete="off"
              value={barId2}
              onChange={setBarId}
            />
            <Label
              style={{ zIndex: "1" }}
              className="form-label"
              htmlFor="OtherStatebarId2"
            >
              Other State Bar ID
            </Label>
          </div>
          <PageLink
            onClick={() => {
              // otherStateData.splice(0, 1);
              // console.log("otherStateData:", otherStateData);
              // setKey((Key) => Key + 1);
              setBarId2("");
              setAdmitDate2(null);
              setState2("");
            }}
          >
            Clear
          </PageLink>
        </div>
        <div className="form-wrapper">
          <div className="input-field-div-wrapper">
            <div className="selectfield-label">State</div>
            <select
              className="dropdown-control-large-insidetextfield"
              name="State3"
              onChange={updateSelectBox}
            >
              <option value="">{state3}</option>
              {States?.map((State: any) => {
                const foundEntry1 = Object.entries(selectedStates).find(
                  ([key, value]) => value === State.StateName
                );
                let [foundKey, foundValue] = ["", ""];
                if (foundEntry1) {
                  [foundKey, foundValue] = foundEntry1;
                }
                console.log("foundEntry1:", foundKey, ":", foundValue);
                return foundKey === "barId1" ||
                  foundKey === "barId2" ||
                  foundKey === "barId4" ? (
                  <></>
                ) : (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="mt-1" style={{ width: "28%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="AdmitDate"
                  value={admitDate3}
                  onChange={(date) => date && setAdmitDate3(date)}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="OtherStatebarId3"
              name="OtherStatebarId3"
              placeholder=""
              autoComplete="off"
              value={barId3}
              onChange={setBarId}
            />
            <Label
              style={{ zIndex: "1" }}
              className="form-label"
              htmlFor="OtherStatebarId3"
            >
              Other State Bar ID
            </Label>
          </div>
          <PageLink
            onClick={() => {
              // otherStateData.splice(0, 1);
              // console.log("otherStateData:", otherStateData);
              // setKey((Key) => Key + 1);
              setBarId3("");
              setAdmitDate3(null);
              setState3("");
            }}
          >
            Clear
          </PageLink>
        </div>
        <div className="form-wrapper">
          <div className="input-field-div-wrapper">
            <div className="selectfield-label">State</div>
            <select
              className="dropdown-control-large-insidetextfield"
              name="State4"
              onChange={updateSelectBox}
            >
              <option value="">{state4}</option>
              {States?.map((State: any) => {
                const foundEntry1 = Object.entries(selectedStates).find(
                  ([key, value]) => value === State.StateName
                );
                let [foundKey, foundValue] = ["", ""];
                if (foundEntry1) {
                  [foundKey, foundValue] = foundEntry1;
                }
                console.log("foundEntry1:", foundKey, ":", foundValue);
                return foundKey === "barId1" ||
                  foundKey === "barId2" ||
                  foundKey === "barId3" ? (
                  <></>
                ) : (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="mt-1" style={{ width: "28%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="AdmitDate"
                  value={admitDate4}
                  onChange={(date) => date && setAdmitDate4(date)}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="OtherStatebarId4"
              name="OtherStatebarId4"
              placeholder=""
              autoComplete="off"
              value={barId4}
              onChange={setBarId}
            />
            <Label
              style={{ zIndex: "1" }}
              className="form-label"
              htmlFor="OtherStatebarId4"
            >
              Other State Bar ID
            </Label>
          </div>
          <PageLink
            onClick={() => {
              // otherStateData.splice(0, 1);
              // console.log("otherStateData:", otherStateData);
              // setKey((Key) => Key + 1);
              setBarId4("");
              setAdmitDate4(null);
              setState4("");
            }}
          >
            Clear
          </PageLink>
        </div>
        <div className="button-wrapper">
          <div className="submit-button-div">
            <Button type="submit" onClick={onSubmitOtherStateBar}>
              Save
            </Button>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDOtherStateBar;
